/* globals $: true, Codsec: true*/

this.Codsec = this.Codsec || {};

this.Codsec.addApp = {
  selectedScanTypes: [],
  currentStep: 'one',
  platform: null,

  hideAll: function() {
    $('#add-app-platform-container').hide();
    $('#add-app-testing-method-container').hide();
    $('#add-app-test-accounts-container').hide();
    $('#add-app-android-options').hide();
    $('#add-app-android-dynamic-options').hide();
    $('#add-app-ios-options').hide();
    $('#add-app-ios-dynamic-options').hide();
    $('#add-app-playstore-container').hide();
    $('#add-app-hockeyapp-container').hide();
    $('#add-app-scan-rules').hide();
    $('#add-backend-test-environment-container').hide();
    $('#add-backend-test-documentation-container').hide();
    $('#add-backend-test-add-app-container').hide();
    $('#add-backend-test-certifications-container').hide();
    $('#add-backend-test-compliance-container').hide();
    $('#add-backend-test-infos-container').hide();
    $('#add-backend-test-finish').hide();
  },

  init: function() {
    this._setupStepButtons();
    this._setupUpload();
    this._setupPlaystoreSubmit();
    this._setupHockeyapp();
  },

  _setupStepButtons: function() {
    var self = this;
    ObjectAssign.polyfill();

    $(".appTypeSelector a").click(function(e) {
      e.preventDefault();

      if ($(this).hasClass('button')) {
        return;
      }

      var selected = $(this).data('type');

      self.hideAll();
      self.platform = selected;

      if (selected !== 'backend') {
        $('#add-app-testing-method-container').show();
      } else {
        self.backendTest = {};
        $('#add-backend-test-environment-container').show();
      }
    });

    $(".testingMethodSelect a").click(function(e) {
      e.preventDefault();

      if ($(this).hasClass('button')) {
        return;
      }

      var selected = $(this).data('type');

      self.hideAll();
      self.method = selected;

      if (selected === 'static') {
        $('#add-app-scan-rules').show();
      } else {
        $('#add-app-test-accounts-container').show();
      }
    });

    $('#add-app-test-accounts-form').on('submit', function(e) {
      e.preventDefault();
      var selectedScanTypes = [];
      $(this).find('input:checked').each(function() {
        selectedScanTypes.push($(this).val());
      });

      self.email = $('#email').val();
      self.password = $('#password').val();
      self.notes = $('#notes').val();

      self.hideAll();
      $('.section.' + self.platform + 'SelectDynamic').show();
    });

    $('#add-app-from-playstore').on('click', function(e) {
      e.preventDefault();
      self.hideAll();
      $('#add-app-playstore-container').show();
    });

    $('.add-app-hockeyapp').on('click', function(e) {
      e.preventDefault();
      self.hideAll();
      $('#add-app-hockeyapp-container').show();
    });

    $('#add-app-scan-rules-form').on('submit', function(e) {
      e.preventDefault();
      var selectedScanTypes = [];
      $(this).find('input:checked').each(function() {
        selectedScanTypes.push($(this).val());
      });

      self.selectedScanTypes = selectedScanTypes;

      self.hideAll();
      $('.section.' + self.platform + 'Select').show();
    });

    $('#add-app-scan-rules-form #add-app-scan-rules-all').on('change', function() {
      if ($(this).is(':checked')) {
        $('#add-app-scan-rules-form .add-app-scan-rules-rule').prop('checked', true);
      } else {
        $('#add-app-scan-rules-form .add-app-scan-rules-rule').prop('checked', false);
      }
    });

    $('.bottom-buttons .back-button').on('click', function(e) {
      e.preventDefault();
      self.hideAll();
      switch ($(this).data('back')) {
        case 'environment':
          $('#add-backend-test-environment-container').show();
          break;

        case 'documentation':
          $('#add-backend-test-documentation-container').show();
          break;

        case 'add-app':
          $('#add-backend-test-add-app-container').show();
          break;

        case 'certifications':
          $('#add-backend-test-certifications-container').show();
          break;
      
        case 'compliance':
          $('#add-backend-test-compliance-container').show();
          break;
      }
    });

    $('#add-backend-documentation').on('click', function() {
      var newElement = $('.backend-test-documentation-file-template').clone(true);
      $(newElement).removeClass('hidden');
      $(newElement).removeClass('backend-test-documentation-file-template');
      $(newElement).children('input').attr('name', 'documentation-files[]');
      $('#backend-test-add-documentation-container').append(newElement);
      return false;
    });

    $('#add-backend-ip-address').on('click', function() {
      var newElement = $('.add-backend-ip-address-row-template').clone();
      $(newElement).removeClass('hidden');
      $(newElement).removeClass('add-backend-ip-address-row-template');
      $(newElement).children('input').attr('name', 'environment[ip][]');
      $('#add-backend-ip-address-container').append(newElement);
      return false;
    });

    $('#add-backend-server-environment-select').on('change', function() {
      var field = $('#add-backend-server-environment-other');
      if ($(this).val() !== 'Other') {
        field.hide();
        field.prop("disabled", true);
      } else {
        field.show();
        field.prop("disabled", false);
      }
    });

    $('#add-backend-test-environment-form').on('submit', function(e) {
      e.preventDefault();
      Object.assign(self.backendTest, $("#add-backend-test-environment-form").serializeObject());
      self.hideAll();
      $('#add-backend-test-documentation-container').show();
    });

    $('#add-backend-endpoint').on('click', function() {
      var newElement = $('.add-backend-endpoint-template').clone();
      $(newElement).removeClass('hidden');
      $(newElement).removeClass('add-backend-endpoint-template');
      $(newElement).children('input').attr('name', 'documentation[endpoint][]');
      $(newElement).children('textarea').attr('name', 'documentation[description][]');
      $('#add-backend-endpoint-container').append(newElement);
      return false;
    });

    $('#add-backend-test-documentation-form').on('submit', function(e) {
      e.preventDefault();
      var result = $("#add-backend-test-documentation-form").serializeObject();
      result.documentation.manual = [];
      for (var index = 0; index < result.documentation.endpoint.length; index++) {
        result.documentation.manual.push({
          endpoint    : result.documentation.endpoint[index],
          description : result.documentation.description[index]
        });
      }
      delete result.documentation.description;
      delete result.documentation.endpoint;
      Object.assign(self.backendTest, result);
      self.hideAll();
      $('#add-backend-test-add-app-container').show();
    });

    $('#backend-test-add-app').on('click', function() {
      var newElement = $('.backend-test-add-app-template').clone(true);
      $(newElement).removeClass('hidden');
      $(newElement).removeClass('backend-test-add-app-template');
      $(newElement).children('input').attr('name', 'apps[]');
      $('#backend-test-add-app-container').append(newElement);
      return false;
    });

    $('#add-backend-test-add-app-form').on('submit', function(e) {
      e.preventDefault();
      self.hideAll();
      $('#add-backend-test-certifications-container').show();
    });

    $('#add-backend-test-certifications-form').on('submit', function(e) {
      e.preventDefault();
      Object.assign(self.backendTest, $("#add-backend-test-certifications-form").serializeObject());
      self.hideAll();
      $('#add-backend-test-compliance-container').show();
    });

    $('#add-backend-test-compliance-form').on('submit', function(e) {
      e.preventDefault();
      Object.assign(self.backendTest, $("#add-backend-test-compliance-form").serializeObject());
      self.hideAll();
      $('#add-backend-test-infos-container').show();
    });

     $('#add-backend-test-infos-form').on('submit', function(e) {
      e.preventDefault();
      Object.assign(self.backendTest, $("#add-backend-test-infos-form").serializeObject());

      $.ajax({
          url: PUBLIC_API_SERVER + '/app/backend/send-quote',
          type: 'POST',
          data: self.backendTest,
          headers: {
            'X-User-UUID': USER_UUID
          },
          dataType: 'json'
        })
        .done(function(result) {
            self.hideAll();
            $('#add-backend-test-finish').show();
        })
        .fail(function(error) {
          alert('Failed to send your request. Please try again or contact support.');
        });
    });

    $('.add-backend-file-upload').on('change', function(e) {
      if (e.target.files.length < 1) {
        return;
      }

      var data = new FormData(),
        file = e.target.files[0],
        element = $(this),
        attrName = element.attr('name');

      data.append('file', file);

      element.hide();
      var progressElement = element.siblings('.binary-upload-progress');

      var percentage = 0;
      var updatePercentage = function(percentage) {
        progressElement.show();
        progressElement.children('span').text(percentage + '%').css('width', percentage + '%');
      }
      updatePercentage(0);

      var progressInterval = setInterval(function() {
        if (percentage >= 75) {
          clearInterval(progressInterval);
        } else {
          percentage += 25;
          updatePercentage(percentage);
        }
      }, 2000);

      $.ajax({
          url: PUBLIC_API_SERVER + '/app/backend/upload-file',
          type: 'POST',
          data: data,
          contentType: false,
          processData: false,
          headers: {
            'X-User-UUID': USER_UUID
          },
          dataType: 'json'
        })
        .uploadProgress(function(e) {
          clearInterval(progressInterval);
          var percentage = '-';

          if (e.lengthComputable) {
            percentage = Math.round((e.loaded * 100) / e.total);
          }

          updatePercentage(percentage);
        })
        .done(function(result) {
          clearInterval(progressInterval);
          updatePercentage(100);
          if (result.success) {
            var fileData = {
              name: file.name,
              url: result.fileUrl
            };
            progressElement.children('span').text('UPLOADED ' + file.name);
            var bracketIndex = attrName.indexOf('[]');
            if (bracketIndex > 0) {
              attrName = attrName.substring(0, bracketIndex);
              self.backendTest[attrName] = self.backendTest[attrName] || [];
              self.backendTest[attrName].push(fileData);
            } else {
              self.backendTest[attrName] = fileData;
            }
          }
        })
        .fail(function(error) {
          element.show();
          progressElement.hide();
          alert('Upload failed. Please try again or contact support.');
        });
    });
  },

  _setupHockeyapp: function() {
    var self = this;

    $('#hockeyapp-apikey-form').on('submit', function(e) {
      e.preventDefault();

      $(this).hide();

      //frontend server has logic for filtering out already used apps
      $.post('/hockeyapp/' + self.platform, {
        apiKey: $(this).find('input[name=apiKey]').val()
      }, function(result) {
        var content = '';
        if (!result.success) {
          content = Codsec.templates.dashboard.hockeyapps({
            error: result.error
          });
        } else {
          content = Codsec.templates.dashboard.hockeyapps({
            apps: result.apps
          });
        }

        $('#hockeyapp-apps-form').html(content);

        $('#hockeyapp-apps-form').show();
      });
    });

    $('#hockeyapp-apps-form').on('submit', function(e) {
      e.preventDefault();

      var appIds = [];

      $('#hockeyapp-apps-form').find('input[name="appId[]"]:checked').each(function() {
        appIds.push($(this).val());
      });

      var platform = self.platform;

      executePost('/user/rescans/' + platform + '/hockeyapp/add', {
          apiKey: $('input[name=apiKey]').val(),
          appIds: appIds,
          rules: self.selectedScanTypes.join(',')
        })
        .done(function() {
          window.location.href = '/';
        })
        .fail(function(error) {
          //@TODO display error
        });
    });
  },

  _setupPlaystoreSubmit: function() {
    var self = this;

    $('#android-playstore-url-form').on('submit', function(e) {
      e.preventDefault();
      $('.blockForm button').hide();
      $('.hiddenLoader').addClass('show');
      executePost('/user/rescans/android/playstore/add', {
          urls: [$(this).find('input[name=url]').val()],
          rules: self.selectedScanTypes.join(',')
        })
        .done(function() {
          window.location.href = '/';
        })
        .fail(function(error) {
          $('#android-playstore-url-form input').focus();
          if (!$('#playAddAppError').length) {
            $('.blockForm button').before("<p id='playAddAppError'>Can't retrieve the App from Play store, please use the APK upload method.");
          }
          $('.blockForm button').text('Try Again');
          $('.blockForm button').css('background-color', 'red');
          $('.blockForm button').show();
          $('.hiddenLoader').removeClass('show');
        });
    });
  },

  _setupUpload: function() {
    var self = this;

    $('.binary-upload-button').on('click', function(e) {
      e.preventDefault();
      $('#binary-upload-file').data('platform', self.platform);
      $('#binary-upload-file').trigger('click');
    });

    $('#binary-upload-file').on('change', function(e) {
      if (e.target.files.length < 1) {
        return;
      }

      var platform,
        data = new FormData(),
        file = e.target.files[0],
        parts = file.name.split('.'),
        extension = parts[parts.length - 1],
        isStatic = self.method !== 'dynamic';

      if (extension !== 'ipa' && extension !== 'apk' && extension !== 'zip') {
        //@TODO display nicer error message
        alert('Invalid file format ' + extension);
        return;
      }

      if (extension === 'zip') {
        platform = 'ios/mono';
        data.append('zipFile', file);
      }

      if (extension === 'apk') {
        platform = 'android';
        data.append('apkFile', file);
      }

      if (extension === 'ipa') {
        platform = 'ios';
        data.append('ipaFile', file);
      }

      var endpoint = '/app/' + (isStatic ? 'analyze' : 'dast') + '/' + platform;

      $('.binary-upload-button').hide();

      if (isStatic) {
        data.append('rules', self.selectedScanTypes.join(','));
      } else {
        data.append('suppliedDetails', JSON.stringify({
          email: self.email,
          password: self.password,
          notes: self.notes
        }));
      }

      // we need to replace the slash in ios/mono in order to find the proper element as slashes are not valid characters in ids
      var progressElement = $('#binary-upload-progress-' + (isStatic ? '' : 'dynamic-') + platform.replace(/\//g, "-"));

      var percentage = 0;
      var updatePercentage = function(percentage) {
        progressElement.show();
        progressElement.children('span').text(percentage + '%').css('width', percentage + '%');
      }
      updatePercentage(0);

      var progressInterval = setInterval(function() {
        if (percentage >= 75) {
          percentage += Math.floor((100-percentage)/2);
          updatePercentage(percentage);
        } else {
          percentage += 25;
          updatePercentage(percentage);
        }
      }, 2000);

      $.ajax({
          url: PUBLIC_API_SERVER + endpoint,
          type: 'POST',
          data: data,
          contentType: false,
          processData: false,
          headers: {
            'X-User-UUID': USER_UUID
          },
          dataType: 'json'
        })
        .uploadProgress(function(e) {
          clearInterval(progressInterval);
          var percentage = '-';

          if (e.lengthComputable) {
            percentage = Math.round((e.loaded * 100) / e.total);
          }

          updatePercentage(percentage);
        })
        .done(function() {
          clearInterval(progressInterval);
          updatePercentage(100);
          window.location.href = '/';
        })
        .fail(function(error) {
          //@TODO display error
        });
    });
  }
};
